import PropTypes from 'prop-types';
import { Label } from 'ypf-pas-general-ui-components';

import './DailyTotal.scss';

const DailyTotal = ({ title, daily, total, isPending }) => (
  <div className="approval-pending ">
    <div className="label-pending">
      <Label icon="" label={title} size="md" sizeValue="md" value="" />
    </div>
    <div className="container-daily-total">
      <h2 className="daily">Diarios</h2>
      <div className="daily-result mt-40">{daily}</div>
      {isPending ? (
        <>
          <h2 className="total">Totales</h2>
          <div className="total-result">{total}</div>
        </>
      ) : null}
    </div>
  </div>
);

export default DailyTotal;

DailyTotal.propTypes = {
  title: PropTypes.string.isRequired,
  daily: PropTypes.number.isRequired,
  total: PropTypes.number,
  isPending: PropTypes.bool
};

DailyTotal.defaultProps = {
  isPending: false,
  total: 0
};
